import { CurrentPostContextProvider } from "@circle-react/contexts";
import { EventItemContent } from "./EventItemContent";
import { MainContent } from "./MainContent";

export const ListViewItem = ({
  event,
  onDestroy,
  onRsvp,
  isThumbnailView = false,
}: any) => (
  <CurrentPostContextProvider post={event}>
    {isThumbnailView ? (
      <MainContent onDestroy={onDestroy} onRsvp={onRsvp} />
    ) : (
      <EventItemContent onDestroy={onDestroy} onRsvp={onRsvp} />
    )}
  </CurrentPostContextProvider>
);
